import apiConfig from 'config';
import axios from 'helpers/axios';
import actions from 'redux/auth/actions';
import storeObject from 'redux/storeDeclaration';

class TokenRefresher {
  constructor() {
    const { apiUrl } = apiConfig;
    this.apiUrl = apiUrl;
  }

  subscribers = [];

  refreshing = false;

  scheduled = null;

  getRefreshing = () => this.refreshing;

  setRefreshing = (state) => {
    this.refreshing = state;
    return this;
  };

  onRefreshed = (token, error) => {
    this.subscribers.map(cb => cb(token, error));
  };

  subscribeTokenRefresh = (cb) => {
    this.subscribers.push(cb);
  };

  schedule = (timeout) => {
    if (this.scheduled) {
      clearTimeout(this.scheduled);
    }
    this.scheduled = setTimeout(() => {
      this.refresh();
    }, timeout);
  }

  refresh = () => {
    this.setRefreshing(true);
    axios
      .post(`${this.apiUrl}/refresh`)
      .then((refreshResponse) => {
        if (
          refreshResponse.data
          && refreshResponse.data.expires_in
        ) {
          this.setRefreshing(false);
          this.onRefreshed(true);
          this.subscribers = [];
          this.schedule(refreshResponse.data.expires_in * 1000);
        } else {
          storeObject.getStore().dispatch(actions.logout({
            remember: true,
            requestLogin: true,
          }));
        }
      })
      .catch((error) => {
        this.setRefreshing(false);
        this.onRefreshed(false, error);
        this.subscribers = [];
      });
  };
}

export default new TokenRefresher();
